export enum TripStatus {
  Active = 0,
  Completed = 1,
  Inactive = 2,
}
